// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.etl {
  margin-right: 1rem;
}
.etl .first {
  margin-top: 1em;
  margin-bottom: 0.5em;
}
.etl .label {
  font-weight: 500;
}
.etl .error {
  color: red;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImV0bC1zY3JpcHQtdXBkYXRlLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksa0JBQUE7QUFDSjtBQUFJO0VBQ0ksZUFBQTtFQUNBLG9CQUFBO0FBRVI7QUFDSTtFQUNJLGdCQUFBO0FBQ1I7QUFFSTtFQUNJLFVBQUE7QUFBUiIsImZpbGUiOiJldGwtc2NyaXB0LXVwZGF0ZS5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5ldGwge1xuICAgIG1hcmdpbi1yaWdodDogMXJlbTtcbiAgICAuZmlyc3Qge1xuICAgICAgICBtYXJnaW4tdG9wOiAxZW07XG4gICAgICAgIG1hcmdpbi1ib3R0b206IDAuNWVtO1xuICAgIH1cblxuICAgIC5sYWJlbCB7XG4gICAgICAgIGZvbnQtd2VpZ2h0OiA1MDA7XG4gICAgfVxuXG4gICAgLmVycm9yIHtcbiAgICAgICAgY29sb3I6IHJlZDtcbiAgICB9XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/etl-v1/etl-script-update/etl-script-update.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AAAI;EACI,eAAA;EACA,oBAAA;AAER;AACI;EACI,gBAAA;AACR;AAEI;EACI,UAAA;AAAR;AACA,4oBAA4oB","sourcesContent":[".etl {\n    margin-right: 1rem;\n    .first {\n        margin-top: 1em;\n        margin-bottom: 0.5em;\n    }\n\n    .label {\n        font-weight: 500;\n    }\n\n    .error {\n        color: red;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
